import { render, staticRenderFns } from "./StoryCard.vue?vue&type=template&id=82fab2d8&scoped=true&"
import script from "./StoryCard.vue?vue&type=script&lang=js&"
export * from "./StoryCard.vue?vue&type=script&lang=js&"
import style0 from "./StoryCard.vue?vue&type=style&index=0&id=82fab2d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fab2d8",
  null
  
)

export default component.exports